import { GET_STAFF_DETAILS } from "../../Utils/types";

const initialState = {
  getStaffDetails: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_STAFF_DETAILS:
      return {
        ...state,
        getStaffDetails: action.payload,
      };
    default:
      return state;
  }
};
